"use client";

import { useState } from "react";
import { ChevronDown, ChevronUp } from "lucide-react";
import { useTranslations } from "next-intl";
import { TimeOfDay } from "@/lib/utils";

const TIME_OPTIONS: { labelKey: "morning" | "afternoon" | "evening"; value: TimeOfDay }[] = [
  { labelKey: "morning", value: "morning" },
  { labelKey: "afternoon", value: "afternoon" },
  { labelKey: "evening", value: "evening" },
];

interface TimeOfDayFilterProps {
  selectedTime: TimeOfDay | null;
  onTimeChange: (time: TimeOfDay | null) => void;
}

export function TimeOfDayFilter({
  selectedTime,
  onTimeChange,
}: TimeOfDayFilterProps) {
  const t = useTranslations("Filters");
  const [expanded, setExpanded] = useState(false);

  const selectTime = (time: TimeOfDay) => {
    onTimeChange(selectedTime === time ? null : time);
  };

  return (
    <>
      <button
        onClick={() => setExpanded(!expanded)}
        className={`inline-flex items-center gap-1 rounded-md border px-3 py-1.5 font-mono text-xs transition-colors ${
          selectedTime || expanded
            ? "border-acid bg-acid text-black"
            : "border-neutral-700 text-neutral-400 hover:border-neutral-500 hover:text-neutral-300"
        }`}
      >
        {t("timeOfDay")}
        {expanded ? (
          <ChevronUp className="h-3 w-3" />
        ) : (
          <ChevronDown className="h-3 w-3" />
        )}
      </button>
      {expanded &&
        TIME_OPTIONS.map(({ labelKey, value }) => {
          const isSelected = selectedTime === value;
          return (
            <button
              key={value}
              onClick={() => selectTime(value)}
              className={`rounded-md border px-3 py-1.5 font-mono text-xs transition-colors ${
                isSelected
                  ? "border-acid bg-acid/10 text-acid"
                  : "border-neutral-700 text-neutral-400 hover:border-neutral-500 hover:text-neutral-300"
              }`}
            >
              {t(labelKey)}
            </button>
          );
        })}
    </>
  );
}
